import React, { useState, useEffect } from "react";
import "../../styles/navBar.scss";
import { Modal, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { NavLink } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { TitleButton, MenuButton, MenuButton1 } from "./Buttons";
//import CloudSocial from "../../asset/image/CSLogo.png";
//import CloudSocial from "../../asset/image/cloudsociallogo.png";
import CloudSocial from "../../asset/image/CloudSocial.png";
import CloudInsights from "../../asset/image/Cloudinsights.png";
import logo from "../../asset/image/CSlogo1.png";
import { Affix } from "rsuite";
import { Book, NoteRounded } from "@material-ui/icons";
import Youtube from "@material-ui/icons/YouTube";
import { Link } from "react-router-dom";
function MyVerticallyCenteredModal(props) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="navbar"
    >
      <Modal.Header closeButton className="modalHeader">
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body closeButton>
        <iframe
          // allow="camera;microphone"
          src="https://cloudsocial.repuso.com/collect"
          // style="border:1px #000000 solid;height:500px;width:100%;"
          height="500px"
          width="100%"
          name="reviews"
          // scrolling="yes"
          // frameborder="1"
          // marginheight="0px"
          // marginwidth="0px"
          // allowfullscreen
        ></iframe>
      </Modal.Body>
    </Modal>
  );
}

const NavBar = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [modalShow, setModalShow] = React.useState(false);
  const [show1, setshow] = useState(false);
  const [show2, setshow1] = useState(false);

  const [main, setmain] = useState(false);
  const timeup = (e) => {
    setmain(!main);
    console.log(main);
  };

  const closeDropDown = () => {
    setmain(false);
    setModalShow(true);
  };

  const dropdownOpen = (e) => {
    setshow(true);
    setshow1(false);
  };
  const dropdownOpenClick = (e) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setshow(!show1);
  };
  const dropdownOpenClick1 = (e) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setshow1(!show2);
  };
  const dropdownClose = (e) => {
    setshow(false);
    setmain(false);
  };

  const dropdownOpen1 = (e) => {
    setshow1(true);
    setshow(false);
  };
  const dropdownClose1 = (e) => {
    setshow1(false);
    setmain(false);
  };
  const dropdownAll = (e) => {
    setshow1(false);
    setshow(false);
    // window.scrollTo({ top: 0 });
  };
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  const handleClick = () => {
    window.open("https://www.cloudsocial.io/managedservice");
  };

  window.addEventListener("scroll", changeBackground);
  // var location = window.location.pathname;
  // console.log("location", location);
  return (
    <div>
      <Affix>
        {/* <div className="affix"></div> */}
        <Navbar
          expand="lg"
          onToggle={timeup}
          expanded={main}
          className={navbar ? "headerActive bottom" : "navbarMain"}
        >
          <Navbar.Brand>
            <Link to="/">
              <img src={CloudSocial} alt="CloudSocial" className="logo" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto">
              <div className="link-tab">
                <NavDropdown
                  title="Solutions"
                  id="basic-nav-dropdown"
                  className="megamenu has-megamenu "
                  show={show1}
                  onMouseEnter={dropdownOpen}
                  onClick={dropdownOpenClick}
                >
                  <div className="dropdown-time" onMouseLeave={dropdownClose}>
                    <div className="innerMenu">
                      <div>
                        <LinkContainer to="/">
                          <NavLink>
                            <Card.Body className="sub-menu-body">
                              <Card.Title
                                className="sub-menu-title"
                                onClick={dropdownClose}
                              >
                                {/* <FormatListBulletedOutlined className="sub-menu-solution" /> */}
                                <img
                                  src={logo}
                                  alt="CloudSocial"
                                  className="sub-menu-solution csLogo"
                                  loading="eager"
                                />
                                CloudSocial
                              </Card.Title>
                              <Card.Text className="sub-menu-text">
                                Social Media Management made easy. Publish
                                content, Respond to mentions, listen and Analyse
                                social metrics
                              </Card.Text>
                            </Card.Body>
                          </NavLink>
                        </LinkContainer>
                      </div>
                      <div>
                        {/* <LinkContainer to="/cloud-insights">
                          <NavLink>
                            <Card.Body className="sub-menu-body">
                              <Card.Title
                                className="sub-menu-title"
                                onClick={dropdownClose}
                              >
                                <img
                                  src={CloudInsights}
                                  alt="CloudInsights"
                                  className="sub-menu-solution csLogo"
                                  loading="eager"
                                />
                                CloudInsights
                              </Card.Title>
                              <Card.Text className="sub-menu-text">
                                Transform web content into rich, coherent, and
                                actionable insights
                              </Card.Text>
                            </Card.Body>
                          </NavLink>
                        </LinkContainer> */}
                      </div>
                      {/* <div>
                        <LinkContainer to="/managed-services">
                          <NavLink>
                            <Card.Body
                              className="sub-menu-body"
                              onClick={dropdownClose}
                            >
                              <Card.Title className="sub-menu-title">
                                <Book className="sub-menu-icon" />
                                ManagedService
                              </Card.Title>
                              <Card.Text className="sub-menu-text">
                                Expert Resources To Handle Queries, Requests,
                                Conversions & Complaints
                              </Card.Text>
                            </Card.Body>
                          </NavLink>
                        </LinkContainer>
                      </div> */}
                      <div>
                        {/* <LinkContainer> */}
                        <NavLink onClick={handleClick}>
                          <Card.Body
                            className="sub-menu-body"
                            onClick={dropdownClose}
                          >
                            <Card.Title className="sub-menu-title">
                              <Book className="sub-menu-icon" />
                              ManagedService
                            </Card.Title>
                            <Card.Text className="sub-menu-text">
                              Expert Resources To Handle Queries, Requests,
                              Conversions & Complaints
                            </Card.Text>
                          </Card.Body>
                        </NavLink>
                        {/* </LinkContainer> */}
                      </div>

                      {/* <div>
                        <LinkContainer to="/">
                          <NavLink>
                            <Card.Body
                              className="sub-menu-body"
                              onClick={dropdownClose}
                            >
                              <Card.Title className="sub-menu-title">
                                <Book className="sub-menu-icon" />
                                ManagedService
                              </Card.Title>
                              <Card.Text className="sub-menu-text">
                                Access the essential reading & resources you’d
                                need to ace at social media marketing
                              </Card.Text>
                            </Card.Body>
                          </NavLink>
                        </LinkContainer>
                      </div> */}
                    </div>
                  </div>
                </NavDropdown>
              </div>
              <div className="link-tab">
                <NavDropdown
                  title="Resources"
                  id="basic-nav-dropdown"
                  className="megamenu has-megamenu fadeIn"
                  show={show2}
                  onMouseEnter={dropdownOpen1}
                  onCLick={dropdownOpenClick1}
                >
                  <div className="dropdown-time" onMouseLeave={dropdownClose1}>
                    <div className="innerMenu">
                      <div>
                        <LinkContainer to="/blog">
                          <NavLink>
                            <Card.Body
                              className="sub-menu-body"
                              onClick={dropdownClose1}
                            >
                              <Card.Title className="sub-menu-title">
                                <Book className="sub-menu-icon" />
                                Blog
                              </Card.Title>
                              <Card.Text className="sub-menu-text">
                                Catch the latest social media trends and updates
                                on CloudSocial functionalities
                              </Card.Text>

                              {/* <a
                            href="https://blog.cloudsocial.io/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link"
                          >
                            <Card.Title className="sub-menu-title">
                              <Book className="sub-menu-icon" />
                              Blog
                            </Card.Title>
                            <Card.Text className="sub-menu-text">
                              Access the essential reading & resources you’d
                              need to ace at social media marketing
                            </Card.Text>
                          </a> */}
                              {/* </LinkContainer> */}
                            </Card.Body>
                          </NavLink>
                        </LinkContainer>
                      </div>
                      <div>
                        <LinkContainer to="/resources/video">
                          <NavLink>
                            <Card.Body
                              className="sub-menu-body"
                              onClick={dropdownClose1}
                            >
                              <Card.Title className="sub-menu-title">
                                <Youtube className="sub-menu-youtube" />
                                Video
                              </Card.Title>
                              <Card.Text className="sub-menu-text">
                                Getting started videos to help you quickly
                                explore the functionalities and get going
                              </Card.Text>
                            </Card.Body>
                          </NavLink>
                        </LinkContainer>
                      </div>
                      <div>
                        <LinkContainer to="/resources/literature">
                          <NavLink>
                            <Card.Body
                              className="sub-menu-body"
                              onClick={dropdownClose1}
                            >
                              <Card.Title className="sub-menu-title">
                                <NoteRounded className="sub-menu-literature" />
                                Literature
                              </Card.Title>
                              <Card.Text className="sub-menu-text">
                                Access the guides to know the step-by-step
                                process for all the functionalities
                              </Card.Text>
                            </Card.Body>
                          </NavLink>
                        </LinkContainer>
                      </div>
                    </div>
                  </div>
                </NavDropdown>
              </div>
              <LinkContainer to="/integration" className="link-tab">
                <NavLink onMouseEnter={dropdownAll} onClick={dropdownClose1}>
                  Integration
                </NavLink>
              </LinkContainer>
              <LinkContainer to="/pricing" className="link-tab">
                <NavLink onMouseEnter={dropdownAll} onClick={dropdownClose1}>
                  Pricing
                </NavLink>
              </LinkContainer>
              {/* <LinkContainer to="/schedule-demo" className="link-tab">
                <NavLink onMouseEnter={dropdownAll} onClick={dropdownClose1}>
                  ScheduleDemo
                </NavLink>
              </LinkContainer> */}

              <NavLink
                href="https://calendly.com/cloudsocial-support/csdemo"
                target="_blank"
                rel="noopener noreferrer"
                className="link-tab"
                onMouseEnter={dropdownAll}
                onClick={dropdownClose1}
              >
                ScheduleDemo
              </NavLink>
              {/* <LinkContainer to="/ReferUs"> */}
              <NavLink
                href="https://cloudsocial.postaffiliatepro.com/"
                target="_blank"
                className="link-tab prefinery-form-cta"
                onMouseEnter={dropdownAll}
                onClick={dropdownClose1}
              >
                ReferUs
              </NavLink>
              {/* </LinkContainer> */}
              {/* <LinkContainer to="/"> */}
              {/* <Modal size="xl" backdrop="static" keyboard={false}>
                <Modal.Body scrollable>
                  <iframe
                    title="Powered by Repuso"
                    allow="camera;microphone"
                    src="https://cloudsocial.repuso.com/collect"
                    // style="border:1px #000000 solid;height:500px;width:100%;"
                    style={{
                      border: "1px #0000000 solid",
                      height: "500px",
                      width: "100%",
                    }}
                    name="reviews"
                    scrolling="yes"
                    frameborder="1"
                    marginheight="0px"
                    marginwidth="0px"
                    allowfullscreen
                    backdrop
                  ></iframe>
                </Modal.Body>
              </Modal>  */}
              {/* <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
              <NavLink
                data-rw-collect-modal="cloudsocial"
                className="link-tab"
                onMouseEnter={dropdownAll}
                onClick={closeDropDown}
              >
                ReviewUs
              </NavLink> */}
            </Nav>
            {/* {location !== "/home1" && (
              <>
                <Nav className="link-button">
                  <LinkContainer to="">
                    <TitleButton />
                  </LinkContainer>
                  <div className="">
                    <MenuButton />
                  </div>
                </Nav>
              </>
            )} */}
            <Nav className="link-button">
              <LinkContainer to="">
                <TitleButton />
              </LinkContainer>
              <div className="">
                <MenuButton1 />
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Affix>
    </div>
  );
};

export default NavBar;
